import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';
const IconAskAQuestion = t0 => {
  const $ = _c(13);
  const {
    className: t1,
    color: t2,
    height: t3,
    width: t4
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const color = t2 === undefined ? colorGray : t2;
  const height = t3 === undefined ? 40 : t3;
  const width = t4 === undefined ? 40 : t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== color) {
    t5 = <path d="M34.9207 35.4407C37.08 33.0814 38.4004 29.9611 38.3613 26.5203C38.3613 22.9203 36.9207 19.6795 34.5613 17.3203C33.5207 25.7203 26.3205 32.2407 17.5613 32.1999H13.3613C15.4816 36.6407 20.0021 39.7203 25.2409 39.6795H39.6001L34.9207 35.4407Z" fill={color} />;
    t6 = <path d="M28.5593 4.7999C25.7593 1.9999 22.0389 0.479502 18.0797 0.399902C9.8797 0.399902 3.2001 7.0407 3.2001 15.1999C3.2001 18.5593 4.32042 21.7999 6.35946 24.3591L6.47978 24.5185L0.359375 30.0405L18.0798 30.0811C26.239 30.0811 32.8798 23.4403 32.8798 15.2811C32.8798 11.3202 31.3595 7.5999 28.5594 4.7999H28.5593ZM18.0797 28.1999L5.4001 28.1593L9.24074 24.7186L8.5595 23.9999C6.40014 21.5999 5.20014 18.4795 5.20014 15.1999C5.20014 8.12028 10.9593 2.35908 18.0797 2.35908C21.5594 2.35908 24.8389 3.71844 27.2389 6.15908C29.6389 8.63876 30.9983 11.8795 30.9983 15.3183C30.9999 22.4403 25.1999 28.1995 18.0795 28.1995L18.0797 28.1999Z" fill={color} />;
    t7 = <path d="M16.7998 19.8794H19.3592V22.0794H16.7998V19.8794Z" fill={color} />;
    t8 = <path d="M18.0795 8.07959C15.5998 8.07959 13.5591 10.1202 13.5591 12.6H16.1591C16.1591 11.5203 17.0388 10.6406 18.1184 10.6406C19.1981 10.6406 20.0778 11.5203 20.0778 12.6C20.0778 13.6797 19.1981 14.5594 18.1184 14.5594H16.7997V18.239H19.3997V16.9594C21.2794 16.4 22.6403 14.6797 22.6403 12.6002C22.5997 10.1205 20.5997 8.07975 18.0795 8.07975L18.0795 8.07959Z" fill={color} />;
    $[0] = color;
    $[1] = t5;
    $[2] = t6;
    $[3] = t7;
    $[4] = t8;
  } else {
    t5 = $[1];
    t6 = $[2];
    t7 = $[3];
    t8 = $[4];
  }
  let t9;
  if ($[5] !== className || $[6] !== height || $[7] !== t5 || $[8] !== t6 || $[9] !== t7 || $[10] !== t8 || $[11] !== width) {
    t9 = <svg className={className} fill="none" height={height} viewBox="0 0 40 40" width={width}>{t5}{t6}{t7}{t8}</svg>;
    $[5] = className;
    $[6] = height;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = width;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};
IconAskAQuestion.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number
};
export default IconAskAQuestion;